module.exports = __webpack_public_path__ + "img/白色公司logo.f763de1d.d9538925.png";